<template>
  <v-btn :id="engagementId" :aria-label="ariaLabelEngagement" flat icon>
    <div class="circle" :style="{backgroundColor: this.ratingColorMap[this.engagementLetter]}">{{engagementLetter}}
    </div>
  </v-btn>
</template>

<script>
  import Colors from '../../mixins/Colors'

  export default {
    name: 'rating-badge',
    props: ['engagement', 'studentName', 'studentId', 'type'],
    mixins: [Colors],
    data () {
      return {
        engagementLetter: this.getEngagementLetter(this.engagement)
      }
    },
    methods: {
      getEngagementLetter (engagement = '') {
        return engagement[0] || 'N'
      }
    },
    computed: {
      ariaLabelEngagement () {
        if (this.studentName) {
          let key = this.type === 'latestEngagementRating' ? 'daily-engagement' : 'average-engagement'
          return `Clickable-${this.studentName}-${key}-${this.engagementLetter}`
        }
      },
      engagementId () {
        if (this.studentName) {
          let key = this.type === 'latestEngagementRating' ? 'daily-engagement' : 'average-engagement'
          return `${this.studentId}-${key}-btn`
        } else {
          return `dashboard-engagement-${this.engagementLetter}`
        }
      }
    }
  }
</script>

<style scoped>
  .circle {
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    text-align: center;
    padding: 4px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/RatingBadge.vue